<template>
    <div class="wrap">
        <div class="shade" v-if="showPop"></div>
        <transition
                name="custom-classes-transition"
                enter-active-class="animated zoomIn"
                leave-active-class="animated zoomOut"
        >
            <div class="el-message-box" v-if="showPop">
                <div class="el-message-box__header">
                    <div class="el-message-box__title">智能复习</div>
                    <!--                    退出-->
                    <div class="btn1" @click="closePop()">
                        <img src="../assets/img/grammarTest/close.png" alt="">
                    </div>
                    <div class="btn2">
                        <img src="../assets/img/grammarTest/music.png" alt="">
                    </div>
                </div>
                <div class="el-message-box__content">
                    <div class="el-message-box__container">
                        <div class="left-title">
                            <div>
                                <img src="../assets/img/grammarTest/book.png" alt="">
                                <p>七年级上册-unit1</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-box">
                        <transition name="el-fade-in-linear" mode="out-in">
                            <!--强制复习的提示语-->
                            <div class="hint-text" v-if="isHint" key="save">
                                <div>最后进行“单元整体回忆”，再次巩固记忆</div>
                                <div></div>
                                <div style="margin-top: 30px;">
                                    <el-button type="success" @click="close">开始回忆</el-button>
                                </div>
                            </div>
                        </transition>
                        <!--练习框-->
                        <transition name="el-fade-in-linear" mode="out-in">

                            <div class="word" style="min-height: 450px;" v-if="isDemo" key="1">
                                <transition-group name="list" tag="div" class="word-box">
                                    <div class="word-item list-item" v-for="(item,index) in 29" :key="index"
                                         @click="showTranslate=!showTranslate">
                                        <div class="item-1" v-if="!showTranslate">
                                            at
                                            <img class="voice" src="../assets/img/grammarTest/volume3.png"
                                                 alt="">
                                            <img class="voice"
                                                 src="../assets/img/grammarTest/volume3_active.png"
                                                 alt="">
                                        </div>
                                        <div class="item-2" v-if="showTranslate">
                                            n.蝙蝠；(网球等的)球拍；(口)打击，猛击
                                        </div>
                                    </div>
                                </transition-group>
                                <div class="exit" @click="goResult">
                                    exit
                                </div>
                            </div>
                        </transition>
                        <transition name="el-fade-in-linear" mode="out-in">
                            <div class="result-box" key="2" v-if="showResult">
                                <div class="left-box">
                                    <div class="test-info">
                                        <img src="../assets/img/grammarTest/dot.png" alt="">
                                        <span>记忆夹生词（个）：</span><span>0</span>
                                    </div>
                                    <div class="test-info">
                                        <img src="../assets/img/grammarTest/dot.png" alt="">
                                        <span>拼写夹生词（个）：</span><span class="bad-test">13</span>
                                    </div>
                                    <div class="test-info">
                                        <img src="../assets/img/grammarTest/dot.png" alt="">
                                        <span>连续识别错误（个）：</span><span>0</span>
                                    </div>
                                    <div class="test-info">
                                        <img src="../assets/img/grammarTest/dot.png" alt="">
                                        <span>连续拼写错误（个）：</span><span>0</span>
                                    </div>
                                    <div class="test-info">
                                        <span>继续学习可获得更多武力值</span>
                                    </div>
                                </div>
                                <div class="right-box">
                                    <div class="top-img-icon">
                                        <img src="../assets/img/grammarTest/test_paper.png" alt="">
                                        <div>复习小结</div>
                                    </div>
                                    <div class="img-icon">
                                        <img src="../assets/img/grammarTest/treasure_box.png" alt="">
                                        <div>本次复习将收获15能量石</div>
                                    </div>
                                    <div class="right-btn">
                                        <el-button type="primary">继续学习</el-button>
                                        <el-button type="danger" @click="closePop()">保存退出</el-button>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "overallMemory",
        props: {
            showPop: {},
        },
        data() {
            return {
                isHint: true,//是否显示强制复习提示语
                isDemo: false,
                showTranslate: false,
                showResult: false
            };
        },
        methods: {
            close() {
                this.isHint = false;
                this.isDemo = true
            },
            closePop() {
                this.$emit('closePop')
            },
            goResult() {
                this.showResult = true
                this.isDemo = false
            }
        },
        created() {

        },
    }
</script>

<style scoped lang='less'>
    .wrap{
        position: relative;
    }
    .shade {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgb(0, 0, 0);
        opacity: 0.2;
        position: fixed;
        pointer-events: auto;
    }

    .el-message-box {
        width: 1020px;
        height: 560px;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 30;
        margin: auto;
        /*min-height: 560px;*/
    }

    .el-message-box__wrapper {
        background: rgba(0, 0, 0, 0.3);
    }

    .el-message-box__header {
        padding: 25px;
        padding-left: 70px;
        border-bottom: 1px solid #dcdcdc;
    }

    .el-message-box__content {
        padding-left: 80px;
    }

    .el-message-box__btns {
        font-size: 14px;
        position: absolute;
        right: 0;
        bottom: 0;
    }



    .left-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div:nth-of-type(1) {
            display: flex;
            align-items: center;

            p {
                font-size: 18px;
            }

            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }


    }

    .content-box {
        height: 450px;
        transition: all .5s;
        overflow-y: scroll;

        .hint-text {
            position: relative;
            height: 450px;
            text-align: center;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            > div:nth-of-type(2) {
                color: #FF626F;
                margin: 5px 0;
            }
        }

        .exit {
            position: absolute;
            bottom: 30px;
            right: 40px;
            width: 71px;
            height: 71px;
            background: #3A85D8;
            opacity: 0.65;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            color: #fff;
            border-radius: 50%;
            cursor: pointer;
            transition: all .5s;
        }

        .exit:hover {
            opacity: 1;
        }
    }


    .word-box {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;

        .word-item {
            width: 170px;
            height: 71px;
            margin: 5px;
            background: linear-gradient(270deg, rgba(55, 205, 215, 1) 0%, rgba(0, 181, 194, 1) 100%);
            border-radius: 4px;
            position: relative;
            font-size: 26px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            cursor: pointer;

            .voice {
                width: 20px;
                height: 20px;
                position: absolute;
                bottom: 8px;
                right: 5px;
            }

            .item-2 {
                font-size: 14px;
                padding: 0 10px;
            }
        }
    }

    .result-box {
        display: flex;
        width: 100%;
        height: 450px;

        .left-box, .right-box {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 18px;
            font-weight: 600;

            .test-info {
                display: flex;
                align-items: center;
                margin: 10px 0;
                justify-content: center;
                padding: 8px 15px;
                border-radius: 3px;
                border: 1px solid #D4D4D4;

                img {
                    width: 30px;
                    margin-right: 10px;
                }

                .bad-test {
                    color: #f56c6c;
                }
            }

            .top-img-icon {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                img {
                    width: 30px;
                    height: 30px;
                }
            }
        }

        .right-box {

            .right-btn {
                margin-top: 30px;
            }
        }
    }

    .list-item {
        display: inline-block;
        margin-right: 10px;
    }

    .list-enter-active, .list-leave-active {
        transition: all 1s;
    }

    .list-enter, .list-leave-to
        /* .list-leave-active for below version 2.1.8 */ {
        opacity: 0;
        transform: translateY(30px);
    }
</style>